



































































import { mapActions, mapGetters, mapState } from 'vuex'
import Facet from '~/components/car/classifieds/search/facets/Facet.vue'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { facetChanged } from '~/store/modules/shared/classifieds/search/action-types'
import { capitalizeSentences } from '~/utils/string'
import { formatNumber } from '~/utils/number'
import CRecentSearchButton from '~/components/shared/configurable/button/CRecentSearchButton.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import SellersResultsToggle from '~/components/car/classifieds/search/results/SellersResultsToggle.vue'
import MapSearchService from '~/services/search/MapSearchService'
import SaveSearchButton from '~/components/car/classifieds/search/facets/search-saving/SaveSearchButton.vue'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    Facet,
    SaveSearchButton,
    CRecentSearchButton,
    SellersResultsToggle
  },
  props: {
    facets: { type: Array, required: true },
    visible: { type: Boolean, required: true },
    numberOfClassified: { type: Number, required: true },
    showSellers: { type: Boolean, default: true }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    }),
    ...mapState(CLASSIFIED_SEARCH_NS, {
      isMapSearch: state => state.flags.isMapSearch,
      categoryIds: state => state.categoryIds
    }),
    isAnyFacetSelected(): boolean {
      return this.facets.some(f => f.isSelected)
    },
    resultsText() {
      const formatedNumber = formatNumber(this.numberOfClassified)
      const text = this.$dep(MapSearchService).resultsTitle(
        this.showSellers,
        this.isMapSearch,
        this.categoryIds,
        formatedNumber
      )

      return capitalizeSentences(text)
    }
  },
  methods: {
    ...mapActions(CLASSIFIED_SEARCH_NS, {
      facetChanged,
      clearFacet: 'clearFacet'
    }),
    handleClearFacet(facetName: string) {
      this.clearFacet({ name: facetName })
    },
    clearAllFacets() {
      const paramsArray = []
      this.facets.forEach(f => {
        if (f.values?.params?.length) {
          const { params } = f.values
          paramsArray.push(params.map(p => p[0]))
        }
      })
      const params = paramsArray.flat().map(u => ({ name: u, value: null }))
      this.facetChanged({
        params
      })
    }
  }
})
